import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Landing from "@/pages/Landing";
import CoachWriteSpeak from "@/pages/CoachWriteSpeak";
import SpeakingServices from "@/pages/SpeakingServices";
import Resources from "@/pages/Resources";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Members from "@/pages/Members";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import SupportRequests from "@/pages/SupportRequests";
import SupportDetail from "@/pages/SupportDetail";
import Mediation from "@/pages/Mediation";
import ReportAssault from "@/pages/ReportAssault";
import PeopleStories from "@/pages/PeopleStories";
import PolicyLibrary from "@/pages/PolicyLibrary";
import Directory from "@/pages/Directory";
import CultureSurvey from "@/pages/CultureSurvey";
import Enquiries from "@/pages/Enquiries";
import Waitlist from "@/pages/Waitlist";
import Partners from "@/pages/Partners";

function App() {
    return (
        <div className="App">
            <AuthProvider>
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<CoachWriteSpeak />} />
                        <Route path="/edi-connect" element={<Landing />} />
                        <Route path="/speaking" element={<SpeakingServices />} />
                        <Route path="/resources" element={<Resources />} />
                        <Route path="/payment/success" element={<PaymentSuccess />} />
                        <Route path="/payment/cancel" element={<PaymentCancel />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/register" element={<Register />} />
                        <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
                            <Route path="/app" element={<Navigate to="/app/dashboard" replace />} />
                            <Route path="/app/dashboard" element={<Dashboard />} />
                            <Route path="/app/support" element={<SupportRequests />} />
                            <Route path="/app/support/:id" element={<SupportDetail />} />
                            <Route path="/app/mediation" element={<Mediation />} />
                            <Route path="/app/survey" element={<CultureSurvey />} />
                            <Route path="/app/report" element={<ReportAssault />} />
                            <Route path="/app/stories" element={<PeopleStories />} />
                            <Route path="/app/policies" element={<PolicyLibrary />} />
                            <Route path="/app/directory" element={<Directory />} />
                            <Route path="/app/enquiries" element={<Enquiries />} />
                            <Route path="/app/waitlist" element={<Waitlist />} />
                            <Route path="/app/partners" element={<Partners />} />
                            <Route path="/app/members" element={<Members />} />
                        </Route>
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </BrowserRouter>
                <Toaster position="top-right" richColors />
            </AuthProvider>
        </div>
    );
}

export default App;
